<template>
  <div class="contais">
    <!-- 面包屑-->
    <div class="cons">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>汽车典当业务</el-breadcrumb-item>
        <el-breadcrumb-item>在当汽车</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 头部数据栏 -->
    <div class="header_con">
      <div class="cont_left">
        <Query @child-event="childData" message="汽车"></Query>
      </div>

      <div class="head_right">
        <div class="head_box">
          <h2 :class="{ head_bo_on: showTitle }">今日新增：{{ toDays }}</h2>
          <h3 :class="{ head_bo_on: showTitle }">典当金额：{{ toDaySum.toFixed(2) }}</h3>
        </div>
        <div class="head_bo">
          <h2 :class="{ head_bo_on: showTitle }">在当汽车：{{ amount }}</h2>
          <h3 :class="{ head_bo_on: showTitle }">在当金额：{{ sum.toFixed(2) }}</h3>
        </div>
      </div>
    </div>

    <div class="head_text_ces">
      <span class="black" @click="getZData">正常存当业务</span>
      <span class="blues" @click="DueToday">今日到期业务</span>
      <span class="blue" @click="newData">今日新增业务</span>
      <span class="yus" @click="overdueData">超期业务</span>
      <span class="jus" @click="lastDay">超期五天业务</span>
    </div>
    <!-- 内容部分 -->
    <div class="cons_cont" v-loading="loading" element-loading-text="拼命加载中...">
      <el-table
        :data="items"
        border
        style="width: 100%"
        height="840"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="dates" label="录入日期" width="160"> </el-table-column>
        <el-table-column prop="piaonum" label="当票号" width="110"> </el-table-column>
        <el-table-column prop="name" label="当户姓名" width="130"> </el-table-column>
        <el-table-column prop="tel" label="联系电话" width="130"> </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" width="100"> </el-table-column>
        <el-table-column prop="brand" label="汽车品牌" width="100"> </el-table-column>
        <el-table-column prop="radio" label="车辆状态" width="100"> </el-table-column>
        <el-table-column prop="startDate" label="开始日期" width="120"> </el-table-column>
        <el-table-column prop="DateClosed" label="到期日期" width="120"></el-table-column>
        <el-table-column prop="overallValuation" label="车辆估值" width="120">
        </el-table-column>
        <el-table-column prop="sum" label="在当金额" width="120"> </el-table-column>
        <el-table-column prop="comprehensive" label="典当综合费" width="100">
        </el-table-column>
        <el-table-column prop="lx" label="典当利息" width="100"> </el-table-column>
        <el-table-column prop="det" label="典当天数" width="100"></el-table-column>
        <el-table-column prop="command" label="续当分期" width="120"></el-table-column>
        <el-table-column prop="parkingFee" label="停车费" width="120"></el-table-column>
        <el-table-column prop="agent" label="经办人" width="120"> </el-table-column>
        <el-table-column prop="reviewer" label="复核" width="120"> </el-table-column>
        <el-table-column fixed="left" label="更多操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row._id)" type="text" size="small"
              >查看</el-button
            >
            <el-button type="text" size="small" @click="xudClick(scope.row)"
              >续当</el-button
            >
            <el-button type="text" size="small" @click="shuClick(scope.row)"
              >赎回</el-button
            >

            <el-button type="text" size="small" @click="stages(scope.row)"
              >分期还款</el-button
            >
            <el-button type="text" size="small" @click="ReturnPart(scope.row)"
              >还部分本金</el-button
            >
            <el-button type="text" size="small" @click="printData(scope.row)"
              >打印当票</el-button
            >
            <el-button
              v-if="shows"
              type="text"
              size="small"
              @click="WechatInform(scope.row)"
              >微信通知</el-button
            >

            <el-button v-if="shows" type="text" size="small" @click="smsInform(scope.row)"
              >短信通知</el-button
            >
            <el-button type="text" size="small" @click="checkPlan(scope.row)"
              >查看还款表</el-button
            >
            <el-button type="text" size="small" @click="conTract(scope.row)"
              >查看合同</el-button
            >

            <el-button type="text" size="small" @click="discount(scope.row)"
              >查看折价协议</el-button
            >
            <el-button type="text" size="small" @click="receipt(scope.row)"
              >查看收款确认书</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 重新提交评估 -->
      <el-dialog
        title="重新评估"
        :visible.sync="dialogVpg"
        width="40%"
        :before-close="dialogVpgClose"
      >
        <!-- :before-close="dialogVpg = false" -->
        <div class="car_conts">
          <span>票号：{{ xudetais.piaonum }}</span>
          <span>车牌号：{{ xudetais.plateNumber }}</span>
          <span>当户：{{ xudetais.name }}</span>
          <span>上次评估金额：{{ xudetais.overallValuation }}</span>
          <span
            >重新评估：<el-input
              placeholder="请输入重新评估价格"
              type="number"
              v-model="pguInput"
              style="width: 20%"
              clearable
          /></span>
          <span>评估人：{{ username }}</span>
          <span>重新评估日期：{{ today }}</span>
          <span class="text_car"
            >**汽车每次续当都需要重新评估当物当前价值，可以和上次评估价格一样</span
          >
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVpgClose">取 消</el-button>
          <el-button type="primary" @click="dialogCxgj(xudetais)">提交评估</el-button>
        </span>
      </el-dialog>

      <!-- 续当弹窗 -->
      <el-dialog title="续当操作:" :visible.sync="dialogTabs" width="40%">
        <div class="con_xu">
          <span>当户姓名： {{ xudetais.name }}</span>
          <span>续当当票： {{ xudetais.piaonum }}</span>
          <span>典当状态： {{ states == true ? "逾期" : "在当" }}</span>
          <span v-if="states == true">逾期天数：{{ yday + "天" }}</span>
          <span>原到期日期： {{ xudetais.DateClosed }}</span>
          <span>典当金额： {{ xudetais.sum }}</span>
          <span
            >选择续当日期:
            <el-date-picker
              v-model="xudetavalue"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @change="days"
            >
            </el-date-picker>
          </span>
          <span>
            续当周期:
            <el-button-group>
              <el-button type="primary" @click="zseven" disabled>7天</el-button>
              <el-button type="primary" @click="zfive" disabled>15天</el-button>
              <el-button type="primary" @click="zthre">30天</el-button>
            </el-button-group>
          </span>
          <span>选择的续当天数：{{ day }}</span>

          <span>
            续当综合费:
            <el-input
              placeholder="请输入续当综合费"
              v-model="inpus"
              style="width: 30%"
              clearable
            />
          </span>
          <span
            >典当利息:
            <el-input
              placeholder="请输入续当利息"
              v-model="lInpus"
              style="width: 30%"
              clearable
            />
          </span>
          <span>续当操作人: {{ username }}</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="rest">取 消</el-button>
          <el-button type="primary" @click="dialogEnd">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 赎当弹窗 -->
      <el-dialog title="赎当操作" :visible.sync="dialogSu" width="40%">
        <div class="contens">
          <span>当户：{{ sudatas.name }}</span>
          <span>票号：{{ sudatas.piaonum }}</span>
          <span>典当状态：{{ yday > 0 ? "逾期" : "在当" }}</span>
          <span>车牌号：{{ sudatas.plateNumber }}</span>
          <span>典当金额：{{ sudatas.sum }}</span>
          <span>
            赎当金额：
            <input v-model="inputPrice" placeholder="请输入内容" />
          </span>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogSu = false">取 消</el-button>
          <el-button type="primary" @click="conFirm(sudatas._id)">确 定 赎 回</el-button>
        </span>
      </el-dialog>

      <!-- 提前还本金弹窗 -->
      <el-dialog
        title="提前还本金"
        :visible.sync="dialogTqh"
        width="40%"
        :before-close="dialogTqhQx"
      >
        <div class="contens">
          <span>车牌号：{{ repay.plateNumber }}</span>
          <span>典当状态：{{ yuDate == 0 ? "在当" : "逾期" }}</span>
          <span v-if="yuDate !== 0">逾期天数：{{ yuDate + "天" }}</span>
          <span>典当金额：{{ repay.sum }}</span>
          <span
            >归还金额：
            <input
              placeholder="请输入归还金额"
              v-model="inputSum"
              type="number"
              clearable
              class="sumInput"
              @blur="blurs"
            />
          </span>
          <span v-if="yuDate !== 0"
            >未付综合费：
            <input
              placeholder="请输入综合费"
              v-model="inputZh"
              type="number"
              clearable
              class="sumInput"
            />
          </span>
          <span v-if="yuDate !== 0"
            >未付利息：
            <input
              placeholder="请输入归还金额"
              v-model="inputLx"
              type="number"
              clearable
              class="sumInput"
            />
          </span>
          <span>归还日期：{{ today }}</span>
          <span>操作人：{{ username }}</span>
          <span style="margin: 0 auto; color: red" v-if="yuDate !== 0"
            >**注意：未付综合费和未付利息，需要先填写归还本金金额后才能计算，以实际收取为准**</span
          >
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogTqhQx">取 消</el-button>
          <el-button type="primary" @click="dialogTqhGh(repay)">确 定 归 还</el-button>
        </span>
      </el-dialog>

      <!-- 查看合同弹窗 -->
      <el-dialog :visible.sync="contraCt">
        <Contract :msgVal="eDetails"></Contract>
      </el-dialog>
      <!-- 折价协议 -->
      <el-dialog :visible.sync="disCount">
        <DisCount :msgVal="discountDetail"></DisCount>
      </el-dialog>
      <!-- 收款确认书 -->
      <el-dialog :visible.sync="receiPt">
        <ReceiPt :msgVal="receiptDetail"></ReceiPt>
      </el-dialog>
    </div>
    <!-- 打票 -->
    <el-dialog title="打票" :visible.sync="dialogFormVisible1" width="50%">
      <div id="print">
        <table width="100%">
          <tr>
            <!-- <th>典当行</th> -->
            <td rowspan="2" width="8%"></td>
            <td width="12%"></td>
            <td width="33%">
              {{ $store.state.name }}
            </td>
            <td width="15%"></td>
            <td id="32%">
              {{ $store.state.tel }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              {{ $store.state.address }}
            </td>
            <td></td>
            <td>{{ $store.state.licence }}</td>
          </tr>
          <tr>
            <td rowspan="3"></td>
            <td></td>
            <td>{{ xudata.name }}</td>
            <td></td>
            <td>{{ xudata.tel }}</td>
          </tr>
          <tr>
            <td></td>
            <td>{{ xudata.address }}</td>
            <td></td>
            <td>{{ xudata.name }}</td>
          </tr>
          <tr>
            <td></td>
            <td>身份证</td>
            <td></td>
            <td>{{ xudata.IdCard }}</td>
          </tr>
        </table>
        <!-- 物品栏 -->

        <table width="100%">
          <tr>
            <td colspan="7"></td>
          </tr>
          <!-- <tr>
              <td colspan="7"></td>
            </tr> -->
          <tr>
            <td width="8%">1</td>
            <td width="15%">{{ xudata.plateNumber }}</td>
            <td width="27%">{{ xudata.models }}</td>
            <td width="5%">1</td>
            <td width="10%">{{ xudata.sum }}</td>
            <td width="5%">{{ xudata.FoldWhen }}</td>
            <td width="26%">
              <div class="sum_pri">
                <span v-for="item in xudata.sum" :key="item.id">{{ item }}</span>
                <span>0</span>
                <span>0</span>
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
        <table width="100%">
          <tr>
            <td width="20%"></td>
            <td width="25%">{{ prices }}</td>
            <td width="10%"></td>
            <td width="18%"></td>
            <td width="28%">
              <div class="sum_pri">
                <span v-for="item in xudata.sum" :key="item.id">{{ item }}</span>
                <span>0</span>
                <span>0</span>
              </div>
            </td>
          </tr>
          <tr>
            <td width="20%"></td>
            <td width="25%">{{ costs }}</td>
            <td width="10%"></td>
            <td width="13%">{{ xudata.comprehensive }}</td>
            <td width="28%">
              <div class="sum_pribox">
                <span>2.4</span>
                <span>0</span>
              </div>
            </td>
            <!-- <td width="10%">{{ xudata.yll }}</td> -->
          </tr>
          <tr>
            <td width="20%"></td>
            <td width="25%">{{ prices }}</td>
            <td width="10%"></td>
            <td width="13%">{{ xudata.sum }}</td>
            <td width="13%"></td>
            <td width="10%"></td>
          </tr>
        </table>
        <table width="100%">
          <tr>
            <td width="12%"></td>
            <td width="7%">{{ n }}</td>
            <td width="5%">{{ y }}</td>
            <td width="5%">{{ r }}</td>
            <td width="7%"></td>
            <td width="7%">{{ ns }}</td>
            <td width="5%">{{ ys }}</td>
            <td width="5%">{{ rs }}</td>
            <td width="40%"></td>
          </tr>
        </table>
        <table width="100%">
          <tr>
            <td width="5%"></td>
            <td width="40%">
              补充约定：逾期续当/赎当将按月费率4.5%收取续当期间典当综合费和利息，当期不足5日的，按5日收取有关费用；并遵守背面《典当须知》。
            </td>
            <td width="30%"></td>
          </tr>
        </table>
        <table width="100%">
          <tr>
            <td width="5%"></td>
            <td width="12%"></td>
            <td width="15%"></td>
            <td width="4%"></td>
            <td width="10%"></td>
            <td width="13%"></td>
            <td width="5%">{{ jn }}</td>
            <td width="5%">{{ jy }}</td>
            <td width="5%">{{ jr }}</td>
            <td width="5%"></td>
          </tr>
        </table>
      </div>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" v-print="'#print'">确定打票</el-button>
      </div>
    </el-dialog>

    <!-- 查看还款表弹窗 -->
    <el-dialog
      title="还款表"
      :visible.sync="dialogCheckPlan"
      width="60%"
      :before-close="CheckPlanClose"
    >
      <CheckPlan
        v-if="dialogCheckPlan"
        :Data="details"
        id="printPdf"
        :token="ACCESS_TOKEN"
        :env="env"
      ></CheckPlan>

      <span slot="footer" class="dialog-footer">
        <el-button v-print="'#printPdf'">打印还款表 或 导出PDF</el-button>
        <el-button @click="CheckPlanClose">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 分期还款弹窗 -->
    <el-dialog
      title="续当（分期还本）"
      :visible.sync="dialogStaging"
      width="40%"
      :before-close="CheckStagingClose"
    >
      <div class="contDetails">
        <span>可续总期数：{{ eStates.command }}期</span>
        <span>还款（续当）期数：第{{ StagingNum }}期</span>
        <span>票号：{{ eStates.piaonum }}</span>
        <span>当户：{{ eStates.name }}</span>
        <span>车牌号：{{ eStates.plateNumber }}</span>
        <span>还款状态：{{ eStates.DateClosed >= today ? "在当" : "逾期" }}</span>
        <span
          >还款金额：{{
            StagingNum == eStates.command
              ? Math.round(eStates.sum / eStates.command) + lxPrice
              : StagingNum > eStates.command / 2
              ? eStates.DateClosed >= this.today
                ? Math.round(eStates.sum / eStates.command) +
                  Math.round(
                    (eStates.sum -
                      Math.round((eStates.sum / eStates.command) * StagingNum)) *
                      0.02
                  )
                : Math.round(eStates.sum / eStates.command) +
                  Math.round(
                    (eStates.sum -
                      Math.round((eStates.sum / eStates.command) * StagingNum)) *
                      0.042
                  )
              : eStates.DateClosed >= this.today
              ? Math.round(eStates.sum / eStates.command) + Math.round(eStates.sum * 0.02)
              : Math.round(eStates.sum / eStates.command) +
                Math.round(eStates.sum * 0.042)
          }}
          元 （本金:{{ Math.round(eStates.sum / eStates.command) }} , 综合费：{{
            StagingNum > eStates.command / 2
              ? eStates.DateClosed >= this.today
                ? Math.round(
                    (eStates.sum -
                      Math.round((eStates.sum / eStates.command) * StagingNum)) *
                      0.02
                  )
                : Math.round(
                    (eStates.sum -
                      Math.round((eStates.sum / eStates.command) * StagingNum)) *
                      0.042
                  )
              : eStates.DateClosed >= this.today
              ? Math.round(eStates.sum * 0.02)
              : Math.round(eStates.sum * 0.042)
          }}
          , 利息：{{ StagingNum == eStates.command ? lxPrice : 0 }}</span
        >
        <span>应付日期：{{ eStates.DateClosed }}</span>
        <span>实付日期：{{ today }}</span>
        <span>经办操作人：{{ username }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmStaging" type="primary">确 定 还 款</el-button>
        <el-button @click="CheckStagingClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import Contract from "../components/Contract.vue";
import DisCount from "../components/cars/DisCount.vue";
import ReceiPt from "../components/cars/ReceiPt.vue";

import Query from "../components/Query.vue";
import CheckPlan from "@/components/cars/CheckPlan.vue";
export default {
  inject: ["reload"],
  name: "Scars",
  data() {
    return {
      ACCESS_TOKEN: "",
      env: "",
      today: "", //今日日期
      items: [], //请求回来的数据
      yuday: "", // 绝当日期
      // detais: [], //详情数据

      states: false, //默认没有逾期
      xudetais: [], //续当的数据
      repay: {}, //提前还本的数据
      sudatas: {}, //赎当的数据

      dialogTabs: false, //续当弹窗
      dialogTabjl: false, //续当记录弹窗
      dialogVpg: false, //重新评估弹窗
      dialogSu: false, //赎当弹窗
      dialogTqh: false, //提前还本弹窗
      contraCt: false, //查看合同弹窗
      disCount: false, //查看折价协议弹窗
      receiPt: false, //查看收款弹窗
      dialogStaging: false, //关闭还款弹窗开关
      inpus: 0, //续当综合费
      lInpus: 0, //续当利息
      token: "", //token
      username: "", //当前登录的名字
      xudetavalue: "", //选择的到期日期
      day: 0, //续当的天数
      das: 0, //续当成功后面新计算的典当天数

      yday: 0, //逾期的天数

      eid: "", //查看合同被点击的id

      pguInput: "", //重新评估的价格

      input: "", //通过车牌号查找
      inputs: "", //通过姓名查找

      amount: 0, //在当数量
      sum: 0, //在当金额
      toDays: 0, //今日新增业务数量
      toDaySum: 0, //今日新增金额

      inputSum: "", //提前归还金额

      yuDate: 0, //逾期天数
      inputZh: 0, //逾期时上期未付综合费
      inputLx: 0, //逾期时上期未付利息
      yspri: 0, //应收

      showTitle: false, //是否缩放

      shows: false, //是否显示发微信和短信通知按钮

      dialogFormVisible1: false, //打票弹窗

      xudata: "",

      prices: "", //大写总金额
      costs: "", //大写综合费

      n: "",
      y: "",
      r: "",
      ns: "",
      ys: "",
      rs: "",

      jn: "",
      jy: "",
      jr: "",

      titles: "",

      dialogCheckPlan: false, //查看还款计划表弹窗开关

      details: {}, //点击还款表的数据

      eDetails: {}, //点击查看合同请求回来的数据
      discountDetail: {}, //点击查看折价协议数据
      receiptDetail: {}, //点击查看收款

      eStates: {}, //点击分期还款的数据

      loading: false,

      StagingNum: 0, //第几次还款

      lxPrice: 0, //利息

      Stages: 0, //分期还款的综合费

      inputPrice: 0, //赎回自行填写的金额
    };
  },
  components: {
    ReceiPt,
    DisCount,
    Contract,
    Query,
    CheckPlan,
  },
  methods: {
    //查询数据结果
    childData(data, day) {
      if (data == "房产") {
        return this.$message.error("未开通房产业务，查点其他的吧");
      }

      let zdata = data.filter(function (product) {
        return (
          product.DateClosed >= day && product.reviewer != "" && product.state == "在当"
        );
      });
      this.items = zdata;
    },

    //请求数据
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").where({DateClosed:_.gte("${this.yuday}"),reviewer:_.neq(""),state:_.eq("在当")}).limit(1000).get()`,
        })
        .then((res) => {
          if (res.data.errcode !== 0) {
            return this.$notify.error({
              title: "错误提示",
              message: "密钥过期啦，请刷新页面",
            });
          }
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.items = res.data.data.reverse(); //所有在当数据
          this.amount = res.data.pager.Total; //所有在当数量

          //计算在当金额
          this.sum = this.countSum(res.data.data);

          //过滤出今天新增加的数据
          let today = res.data.data.filter((item) => {
            return item.CheckTheDate == dayjs().format("YYYY-MM-DD");
          });
          this.toDays = today.length;

          //计算今日新增金额
          this.toDaySum = this.countSum(today);
        });
    },

    //查看更多点击事件
    handleClick(events) {
      this.$router.push({ path: "/Car/CarDetail", query: { id: events } });
    },

    //续当 重新评估弹窗
    xudClick(eves) {
      this.xudetais = eves;
      //先判断该业务是否逾期
      if (eves.DateClosed >= this.today) {
        //没逾期，不做任何操作
        this.states = false;
        this.yday = 0;
      } else {
        //逾期
        this.states = true;
        //计算逾期天数
        this.yday = dayjs().diff(dayjs(eves.DateClosed), "day");
      }

      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("assess_record").where({piaonum:"${eves.piaonum}"}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (res.data.data.length == 0) {
            this.dialogVpg = true;
          } else {
            let num = res.data.data.filter((item) => {
              return item.date == this.today;
            });
            if (num.length > 0) {
              this.dialogTabs = true;
            } else {
              this.dialogVpg = true;
            }
          }
        });
    },
    //续当自定义选择日期事件
    days(e) {
      if (e == null) {
        this.day = 0;
        this.inpus = 0;
        this.lInpus = 0;
      } else {
        this.day = dayjs(e).diff(dayjs(this.xudetais.DateClosed), "day");
        this.inpus = 0;
        this.lInpus = 0;
        this.das = Number(this.xudetais.det) + Number(this.day);
      }
    },

    //提交评估
    dialogCxgj(event) {
      if (this.pguInput !== "" && this.pguInput > "0") {
        this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("car_data").doc("${event._id}").update({data:{overallValuation:"${this.pguInput}"}})`,
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              this.addAssess(this.xudetais);
            } else {
              this.$notify.error({
                title: "错误",
                message: "请刷新页面再试",
              });
            }
          });
      } else {
        this.$notify({
          title: "警告",
          message: "评估价格必须填写，不可填0",
          type: "warning",
        });
      }
    },
    //重新估值成功，添加估值记录
    addAssess(event) {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("assess_record").add({data:{piaonum:"${event.piaonum}",plateNumber:"${event.plateNumber}",name:"${event.name}",sum:"${event.overallValuation}",newPrice:"${this.pguInput}",agent:"${this.username}",date:"${this.today}",state:"续当评估"}})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$notify({
              title: "成功",
              message: `${this.xudetais.name}当物已重新估值`,
              type: "success",
            });
            this.reload();
          }
        });
    },
    //取消评估
    dialogVpgClose() {
      this.dialogVpg = false;
      this.pguInput = "";
    },

    //续当成功后，添加数据到数据库
    addxus() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{stas:"续当",ticketnumber:"${
            this.xudetais.piaonum
          }",name:"${this.xudetais.name}",itemname:"汽车-${
            this.xudetais.plateNumber
          }",xuday:"${this.today}",overdate:"${dayjs(this.xudetais.DateClosed)
            .add(1, "day")
            .format("YYYY-MM-DD")}",enddate:"${this.xudetavalue}",dday:"${
            this.day
          }",pri:"${this.xudetais.sum}",xupri:"${this.inpus}",lx:"${this.lInpus}",ytdy:"${
            this.yday
          }",pena:"0",yspri:"${Number(this.inpus) + Number(this.lInpus)}",rece:"${
            Number(this.inpus) + Number(this.lInpus)
          }",couqons:"汽车业务未开放优惠券",couqonmoney:"0",xuname:"${
            this.username
          }",type:"汽车"}})`,
        })
        .then((rs) => {
          if (rs.data.errcode == 0) {
            this.$notify({
              title: "续当成功",
              message: "该当户的业务已续当成功",
              type: "success",
            });
            this.reload();
          }
        });
    },
    // 点击确定续当的时候
    dialogEnd() {
      //总的典当综合费
      let zpri = Number(this.xudetais.comprehensive) + Number(this.inpus);
      //总的利息
      let lx = Number(this.xudetais.lx) + Number(this.lInpus);

      setTimeout(() => {
        this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("car_data").doc("${this.xudetais._id}").update({data:{DateClosed:"${this.xudetavalue}",det:"${this.das}",comprehensive:"${zpri}",lx:"${lx}"}})`,
          })
          .then((rex) => {
            if (rex.data.errcode == 0) {
              this.addxus();
            }
          });
      }, 800);
    },
    //续当弹窗取消操作

    // 点击续当取消
    rest() {
      this.dialogTabs = false;
      this.xudetavalue = "";
      this.inpus = 0;
      this.lInpus = 0;
      this.day = 0;
    },
    // 点击续当取消结束

    //赎回操作开始
    shuClick(sdata) {
      // 先判断是否逾期
      if (sdata.DateClosed >= this.today) {
        //没逾期
        this.states = false;
        this.yday = 0;
      } else {
        //逾期了
        this.yday = dayjs().diff(dayjs(sdata.DateClosed), "day");
        this.states = true;
      }

      this.sudatas = sdata;
      this.inputPrice = sdata.sum;

      this.dialogSu = !this.dialogSu;
    },
    //确定赎回
    conFirm(id) {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").doc("${id}").update({data:{state:"赎当"}})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$notify({
              title: "赎回成功",
              message: "当前物品已赎当成功",
              type: "success",
            });
            //添加流水
            this.axios
              .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
                env: `${this.userData.env}`,
                query: `db.collection("yxus_record").add({data:{stas:"赎当",ticketnumber:"${this.sudatas.piaonum}",name:"${this.sudatas.name}",itemname:"汽车-${this.sudatas.plateNumber}",xuday:"${this.today}",overdate:"/",enddate:"/",dday:"/",pri:"${this.sudatas.sum}",xupri:"/",lx:"/",ytdy:"${this.yday}",pena:"0",yspri:"${this.sudatas.sum}",rece:"${this.inputPrice}",couqons:"汽车业务未开放优惠券",couqonmoney:"0",xuname:"${this.username}",type:"汽车"}})`,
              })
              .then(() => {
                this.reload();
              });
          }
        });
    },
    //赎回操作结束

    //取消提前还本
    dialogTqhQx() {
      this.dialogTqh = false;
      (this.inputSum = ""), (this.inputLx = 0), (this.inputZh = 0);
    },

    // 点击查看合同
    conTract(event) {
      this.eDetails = event;
      this.contraCt = true;
    },
    // 点击查看折价
    discount(event) {
      this.discountDetail = event;
      this.disCount = true;
    },
    // 点击查看收款
    receipt(event) {
      this.receiptDetail = event;
      this.receiPt = true;
    },

    //点击查看还款表
    checkPlan(event) {
      this.details = event;

      if (event.command == undefined || event.command == 0) {
        this.$alert("该用户没有办理分期", "提示", {
          confirmButtonText: "关闭提示",
        });
      } else {
        this.dialogCheckPlan = true;
      }
    },
    //关闭还款计划表
    CheckPlanClose() {
      this.dialogCheckPlan = false;
    },

    //点击分期还款
    stages(event) {
      this.eStates = event;

      if (event.command == undefined || event.command == 0) {
        this.$alert("该用户没有办理分期", "提示", {
          confirmButtonText: "关闭提示",
        });
      } else {
        this.loading = true;
        //查找续当记录
        this.axios
          .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("yxus_record").where({ticketnumber:"${event.piaonum}"}).get()`,
          })
          .then((res) => {
            (this.loading = false),
              (this.dialogStaging = true),
              res.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });

            let arrData = res.data.data.filter((item) => {
              return item.stas == "分期还款";
            });

            if (event.isType == true) {
              //如果是1+N
              this.StagingNum = arrData.length + 1;
            } else {
              //0+N
              this.StagingNum = arrData.length + 2;
            }

            let comm = event.command / 2;
            let staNum =
              event.isType == true
                ? Number(arrData.length) + 1
                : Number(arrData.length) + 2;
            if (staNum <= comm) {
              this.Stages =
                event.DateClosed >= this.today
                  ? Math.round(event.sum * 0.02)
                  : Math.round(event.sum * 0.042); //综合费
            } else if (staNum == event.command) {
              this.Stages = 0;
            } else {
              this.Stages =
                event.DateClosed >= this.today
                  ? Math.round(
                      (event.sum - Math.round((event.sum / event.command) * staNum)) *
                        0.02
                    )
                  : Math.round(
                      (event.sum - Math.round((event.sum / event.command) * staNum)) *
                        0.042
                    );
            }

            let com = Number(event.command) + 1;
            let comandArr = [];
            for (let i = 1; i < com; i++) {
              comandArr.push(
                Math.round(
                  (event.sum - Math.round((event.sum / event.command) * i)) * 0.003
                )
              );
            }
            //  this.lxPrice = this.Sum(comandArr)
          });
      }
    },

    //分期还款总利息求和

    Sum(event) {
      let s = 0;
      for (let i in event) {
        s += event[i];
        s += "+";
      }
      s = s.substring(0, s.length - 1);
      return eval(s) || 0;
    },

    //确定分期还款
    confirmStaging() {
      //把典当结束日期增加30天/期
      this.$confirm("确定本期还款", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("car_data").doc("${
                this.eStates._id
              }").update({data:{DateClosed:"${dayjs(this.eStates.DateClosed)
                .add(30, "day")
                .format("YYYY-MM-DD")}",det:"${
                Number(this.eStates.det) + 30
              }",comprehensive:"${Number(this.eStates.comprehensive) + this.Stages}"}})`,
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                //添加流水
                this.axios
                  .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query: `db.collection("yxus_record").add({data:{stas:"分期还款",ticketnumber:"${
                      this.eStates.piaonum
                    }",name:"${this.eStates.name}",itemname:"汽车-${
                      this.eStates.plateNumber
                    }-${"第" + this.StagingNum + "期还款"}",xuday:"${
                      this.today
                    }",overdate:"${dayjs(this.eStates.DateClosed)
                      .add(1, "day")
                      .format("YYYY-MM-DD")}",enddate:"${dayjs(this.eStates.DateClosed)
                      .add(30, "day")
                      .format("YYYY-MM-DD")}",dday:"30",pri:"${
                      this.eStates.sum
                    }",xupri:"${this.Stages}",lx:"${
                      Number(this.StagingNum + 2) == this.eStates.command
                        ? this.lxPrice
                        : 0
                    }",ytdy:"${
                      this.eStates.DateClosed < this.today
                        ? dayjs().diff(this.eStates.DateClosed, "day")
                        : 0
                    }",pena:"0",yspri:"${
                      Number(this.StagingNum + 2) == this.eStates.command
                        ? Math.round(this.eStates.sum / this.eStates.command) +
                          this.lxPrice
                        : Math.round(this.eStates.sum / this.eStates.command) +
                          this.Stages
                    }",rece:"${
                      Number(this.StagingNum + 2) == this.eStates.command
                        ? Math.round(this.eStates.sum / this.eStates.command) +
                          this.lxPrice
                        : Math.round(this.eStates.sum / this.eStates.command) +
                          this.Stages
                    }",couqons:"汽车业务未开放优惠券",couqonmoney:"0",xuname:"${
                      this.username
                    }",type:"汽车"}})`,
                  })
                  .then((rs) => {
                    if (rs.data.errcode == 0) {
                      this.$notify({
                        title: "还款成功",
                        message: "业务分期还款成功",
                        type: "success",
                      });
                      this.reload();
                    }
                  });
              } else {
                this.$message.error("操作失败，请刷新页面再试，或检查网络是否可用");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //关闭分期还款按钮
    CheckStagingClose() {
      (this.dialogStaging = false), (this.eStates = {}), (this.StagingNum = 0);
    },

    //点击按钮7天
    zseven() {
      this.xudetavalue = dayjs(this.xudetais.DateClosed)
        .add(7, "day")
        .format("YYYY-MM-DD");
      this.day = 7;
      this.das = Number(this.xudetais.det) + Number(7);
    },
    //点击按钮15天
    zfive() {
      this.xudetavalue = dayjs(this.xudetais.DateClosed)
        .add(15, "day")
        .format("YYYY-MM-DD");
      this.day = 15;
      this.das = Number(this.xudetais.det) + Number(15);
    },
    //点击按钮30天
    zthre() {
      this.xudetavalue = dayjs(this.xudetais.DateClosed)
        .add(30, "day")
        .format("YYYY-MM-DD");
      this.day = 30;
      this.das = Number(this.xudetais.det) + Number(30);

      // 逾期续当综合费和利息
      if (this.states == true) {
        this.inpus = Math.round(this.xudetais.sum * 0.042); //逾期续当综合费
        this.lInpus = Math.round(this.xudetais.sum * 0.0032); //逾期续当利息
      } else {
        //没逾期续当综合费和利息
        this.inpus = Math.round(this.xudetais.sum * 0.02); //续当综合费
        this.lInpus = 0; //续当利息
      }
    },
    //续当操作结束

    //通过条件查找
    queryClick() {
      this.$alert("该功能暂不可用", "温馨提示", {
        confirmButtonText: "确定",
      });
    },
    queryClickName() {
      this.$alert("该功能暂不可用", "温馨提示", {
        confirmButtonText: "确定",
      });
    },

    //提前还本部分本金
    ReturnPart(event) {
      if (event.command > 0) {
        //分期业务
        this.$alert(
          "已办理分期业务暂不支持归还部分本金，请按期还款，如需提前归还部分本金，需要终止分期业务或重新办理分期，具体问题请联系管理员",
          "提示",
          {
            confirmButtonText: "确定",
          }
        );
      } else {
        //未付分期业务
        if (event.DateClosed < this.today) {
          // 逾期了
          this.yuDate = dayjs().diff(dayjs(event.DateClosed), "day");
        } else {
          //没逾期
          this.yuDate = 0;
        }
        this.repay = event;
        this.dialogTqh = !this.dialogTqh;
      }
    },
    //输入本金输入框失去焦点事件
    blurs() {
      if (this.yuDate !== 0) {
        //逾期时
        if (this.inputSum !== "") {
          //逾期时执行计算综合费和利息
          this.inputZh = Math.round(Number(this.inputSum) * 0.022);
          //利息
          this.inputLx = Math.round(Number(this.inputSum) * 0.00316);
          this.yspri =
            Number(this.inputSum) +
            Math.round(Number(this.inputSum * 0.022)) +
            Math.round(Number(this.inputSum * 0.00316));
        } else {
          (this.inputZh = 0), (this.inputLx = 0);
        }
      } else {
        //没逾期时
        this.yspri = this.inputSum;
      }
    },

    //提前还本金确定按钮
    dialogTqhGh(event) {
      if (this.inputSum !== "" && this.inputSum > "0") {
        this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("car_data").doc("${event._id}").update({data:{sum:"${
              Number(event.sum) - Number(this.inputSum)
            }"}})`,
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              this.$notify({
                title: "归还成功",
                message: `该当户的已归还${this.inputSum}`,
                type: "success",
              });

              //添加流水
              this.axios
                .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
                  env: `${this.userData.env}`,
                  query: `db.collection("yxus_record").add({data:{stas:"还本",ticketnumber:"${
                    this.repay.piaonum
                  }",name:"${this.repay.name}",itemname:"汽车-${
                    this.repay.plateNumber
                  }",xuday:"${this.today}",overdate:"/",enddate:"/",dday:"/",pri:"${
                    Number(this.repay.sum) - Number(this.inputSum)
                  }",xupri:"${this.inputZh}",lx:"${this.inputLx}",ytdy:"${
                    this.yuDate
                  }",pena:"0",yspri:"${this.yspri}",rece:"${
                    Number(this.inputSum) + Number(this.inputZh) + Number(this.inputLx)
                  }",couqons:"汽车业务未开放优惠券",couqonmoney:"0",xuname:"${
                    this.username
                  }",type:"汽车"}})`,
                })
                .then((rs) => {
                  if (rs.data.errcode == 0) {
                    this.reload();
                  }
                });
            }
          });
      } else {
        //当归还本金输入框为空或等于0时
        this.$message.error("请正确填写归还本金，不能为 0");
      }
    },

    //通过颜色筛选
    tableRowClassName({ row }) {
      //逾期、绝当鉴定日期
      let day = dayjs().subtract(5, "day").format("YYYY-MM-DD");
      //逾期
      if (row.DateClosed > day && row.DateClosed < this.today) {
        return "success-row";
      }
      if (row.DateClosed == day) {
        return "warning-row";
      }
      //今日新增业务
      if (row.CheckTheDate == this.today) {
        return "today-row";
      }
      //今日到期业务
      if (row.DateClosed == this.today) {
        return "tod-row";
      }

      return "";
    },
    //计算总金额
    countSum(data) {
      //计算在当金额
      let str = "";
      for (let i in data) {
        str += data[i].sum;
        str += "+";
      }
      str = str.substring(0, str.length - 1);
      return eval(str) || 0;
    },

    //点击转台按钮筛选
    getZData() {
      this.reload();
    },
    //今日到期按钮
    DueToday() {
      this.shows = true;
      // 过滤所有今天到期的数据
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").where({reviewer:_.neq(""),state:_.eq("在当"),DateClosed:_.eq("${this.today}")}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = res.data.data;
          this.amount = res.data.pager.Total;

          //计算总金额
          this.sum = this.countSum(res.data.data);
        });
    },
    //今天新增按钮
    newData() {
      //过滤所有今天新增的数据
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").where({reviewer:_.neq(""),state:_.eq("在当"),CheckTheDate:_.eq("${this.today}")}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = res.data.data;
          this.amount = res.data.pager.Total;

          //计算总金额
          this.sum = this.countSum(res.data.data);
        });
    },
    //逾期的数据
    overdueData() {
      //逾期、绝当鉴定日期
      let day = dayjs().subtract(5, "day").format("YYYY-MM-DD");
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").where({reviewer:_.neq(""),state:_.eq("在当"),DateClosed:_.lt("${this.today}")}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          let item = res.data.data.filter((item) => {
            return item.DateClosed > day;
          });
          this.items = item;
          this.amount = item.length;
          //计算总金额
          this.sum = this.countSum(item);
        });
    },
    //逾期最后一天
    lastDay() {
      let day = dayjs().subtract(5, "day").format("YYYY-MM-DD");
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").where({reviewer:_.neq(""),state:_.eq("在当"),DateClosed:_.eq("${day}")}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = res.data.data;
          this.amount = res.data.pager.Total;
          //计算总金额
          this.sum = this.countSum(res.data.data);
        });
    },

    //微信通知按钮
    WechatInform(event) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.Acc, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({idcard:"${event.IdCard}"}).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (res.data.data[0] == undefined) {
            this.$alert(
              "该当户的业务没有绑定微信，请提醒该当户关注公众号，并填写个人信息",
              {
                confirmButtonText: "确定",
              }
            );
          } else {
            this.SendWechatIndorm();
          }
        });
    },

    //发送微信通知
    SendWechatIndorm() {},

    //打印当票
    printData(event) {
      this.xudata = event;
      this.dialogFormVisible1 = !this.dialogFormVisible1;

      this.n = dayjs(event.startDate).year();
      this.y = dayjs(event.startDate).month() + 1;
      this.r = dayjs(event.startDate).date();
      this.ns = dayjs(event.DateClosed).year();
      this.ys = dayjs(event.DateClosed).month() + 1;
      this.rs = dayjs(event.DateClosed).date();

      this.jn = dayjs(event.dates).year();
      this.jy = dayjs(event.dates).month() + 1;
      this.jr = dayjs(event.dates).date();

      this.prices = this.digitUppercase(event.sum);
      this.costs = this.digitUppercase(event.comprehensive);
    },

    //阿拉伯数字转大写

    digitUppercase(n) {
      let fraction = ["角", "分"];
      let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      let unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"],
      ];
      let head = n < 0 ? "欠" : "";
      n = Math.abs(n);
      let s = "";
      for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(
          /零./,
          ""
        );
      }
      s = s || "整";
      n = Math.floor(n);
      for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = "";
        for (let j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
      }
      return (
        head +
        s
          .replace(/(零.)*零元/, "元")
          .replace(/(零.)+/g, "零")
          .replace(/^整$/, "零元整")
      );
    },
  },
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //ACCESS_TOKEN

    //获取到this.ACCESS_TOKEN
    // new Promise((resolve)=>{

    //   resolve(
    //     this.getTokens(),
    //     //获取当前登录的用户数据
    //   this.getUserToken()
    //   )
    // }).then

    this.getTokens(), this.getUserToken();

    this.today = dayjs().format("YYYY-MM-DD");
    this.yuday = dayjs().subtract(5, "day").format("YYYY-MM-DD"); //计算绝当|逾期的终止日期
  },

  mounted() {
    setTimeout(() => {
      this.getData();
      this.username = this.userData.username;
      this.titles = this.userData.title;
      this.env = this.userData.env;
    }, 600);

    if (document.body.clientWidth < 1446) {
      this.showTitle = true;
    } else {
      this.showTitle = false;
    }
  },
};
</script>
<style scoped>
.cons {
  background-color: #ffffff;
  padding: 15px;
}
.details {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.detai_left {
  display: flex;
  flex-direction: column;
}
.detai_left span {
  margin: 15px;
}
.con_xu {
  display: flex;
  flex-direction: column;
}
.con_xu span {
  margin: 15px 20px;
}

.header_con {
  margin: 15px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.head_right {
  width: 38%;
  height: 170px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.head_box {
  width: 40%;
  height: 100px;
  background-color: #2889e4;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-weight: bolder;
  font-size: 16px;
}
.head_bo {
  width: 40%;
  height: 100px;
  background-color: #2889e4;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-weight: bolder;
  font-size: 16px;
}
.head_bo h3 {
  margin: 0.5% 0;
}
.head_box h3 {
  margin: 0.5% 0;
}
.head_bo_on {
  font-size: 16px;
  font-weight: bolder;
}

.ces {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* margin: 4px 0; */
  width: 40%;
}
.cont_left {
  width: 60%;
  /* height: 150px; */
  background-color: #ffffff;
}

.bts {
  width: 30%;
}
.con_xu {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.car_conts {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
}
.car_conts span {
  margin: 10px 0;
}
.text_car {
  color: red;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.contens {
  display: flex;
  flex-direction: column;
}
.contens span {
  margin: 12px 0;
}
.sumInput {
  width: 30%;
  height: 30px;
}
.head_text_ces {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.black {
  border-style: solid;
  border-width: medium;
  /* background-color: #9e9e9e; */
}
.blues {
  border-style: solid;
  border-width: medium;
  margin: 0 10px;
  color: #a2b6d4;
}
.blue {
  border-style: solid;
  border-width: medium;
  color: #90e95c;
  margin: 0 20px;
}
.yus {
  border-style: solid;
  border-width: medium;
  color: #ccc22d;
  margin: 0 20px;
}
.jus {
  border-style: solid;
  border-width: medium;
  color: #fa9393;
  margin-right: 60px;
}
/*今日新增样式*/
.el-table >>> .today-row {
  background: #9fe079cb;
}
/* 快绝当样式 */
.el-table >>> .warning-row {
  background: #fa9393;
}
/* 逾期样式 */
.el-table >>> .success-row {
  background: #ccc22d;
}
/* 今天到期的业务 */
.el-table >>> .tod-row {
  background: #a2b6d4;
}
td {
  /* width: 100%; */
  height: 20px;
  /* border: 1px solid black; */
  font-size: 12px;
  text-align: center;
}
.sum_pri {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.sum_pri span {
  width: 10px;
  margin: 0 5px;
}
.contDetails {
  display: flex;
  flex-direction: column;
}
.contDetails span {
  margin: 10px 0;
}
</style>
